export default __webpack_public_path__ + "static/balloons_th-0cdbda5ccacd9c6654bfce3e79389e21.jpg";